/* eslint-disable */
import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import "./awsheader.less";

import accImg from "./assets/accenture.png";
import awsImg from "./assets/samlogo.png";

const mapStateToProps = ({ virtualUser, virtualEvent }) => ({
  virtualUser, virtualEvent
});

@withRouter
@connect(mapStateToProps)
class AwsHeader extends Component {
  logout = () => {
    const { dispatch } = this.props;

    dispatch({
      type: "virtaluser/LOGOUT",
    });
  };

  goHome = () => {
    const { virtualEvent: { homescreen } = {} } = this.props;

    window.location.href = `#/virtual/main?scene=${homescreen}`;
  };
  handleFeedback = () => {
    // window.open('https://form.jotform.com/262842092857062', '_blank')
    window.open('https://neonicheintegrated.in/2026/aws/samriddhi/feedback/virtual_day2.php', '_blank')
  }

  getCurrentScene = () => {
    const hash = window.location.hash;

    // Example:
    // #/virtual/main?scene=d331828-7dcd-cd40-aac-0651acbae4aa

    const queryString = hash.split("?")[1];

    if (!queryString) {
      return null;
    }

    const params = new URLSearchParams(queryString);

    return params.get("scene");
  };

  getInitials = (name) => {
    if (!name || !name.trim()) {
      return "NA";
    }

    return name
      .trim()
      .split(/\s+/)
      .slice(0, 2)
      .map((word) => word.charAt(0))
      .join("")
      .toUpperCase();
  };

  render() {
    const {
      virtualUser: { name } = {},
      virtualEvent: { homescreen } = {},
    } = this.props;

    const initials = this.getInitials(name);
    const currentScene = this.getCurrentScene();

    const showHomeButton =
      homescreen && currentScene !== homescreen;


    return (
      <header className="aws-header">
        <div className="aws-header__brand">
          <img
            className="aws-header__accenture"
            src={accImg}
            alt="Accenture"
          />

          {showHomeButton && (
            <button
              type="button"
              className="aws-header__home"
              onClick={this.goHome}
            >
              Home
            </button>
          )}
          <button
            type="button"
            className="aws-header__feedback"
            onClick={this.handleFeedback}
          >
            Feedback
          </button>
        </div>

        <div className="aws-header__user">
          <img
            className="aws-header__aws-logo"
            src={awsImg}
            alt="AWS"
            style={{ marginRight: '60px' }}
          />

          <span
            className="aws-header__avatar"
            aria-label={`User ${name || ""}`}
          >
            {initials}
          </span>

          <button
            type="button"
            className="aws-header__logout"
            onClick={this.logout}
          >
            Log out
          </button>
        </div>
      </header>
    );
  }
}

export default AwsHeader;